import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { formatISO } from 'date-fns';
import { DirectStepService } from './direct-step.service';
import { StepSupplierComponent } from '../../step-supplier/step-supplier.component';
import { IonSkeletonText } from '@ionic/angular/standalone';
import { AsyncPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-direct-question-handler',
  templateUrl: './direct-question-handler.component.html',
  styleUrls: ['./direct-question-handler.component.scss'],
  imports: [StepSupplierComponent, IonSkeletonText, AsyncPipe],
})
export class DirectQuestionHandlerComponent {
  public directStepService: DirectStepService = inject(DirectStepService);

  /**
   * Generates a hash based on the current date which is used as the current
   * sessionId. Needed to make the clue-component work correctly.
   */
  public generateHash(): string {
    return formatISO(new Date(), { representation: 'date' })
      .split('')
      .reduce((a: number, b: string) => {
        a = (a << 5) - a + b.charCodeAt(0);
        return a && a;
      }, 0)
      .toString();
  }
}
